export default __webpack_public_path__ + "locales/lo-LA/SendInviteDialog.json?hash=3c5702bfacb3a1c328217f32217d1471";